<template>
     <div class="centerInfo">
		
		<div id="testVideo"></div>
		
	</div>
</template>

<script>


export default {
    data() {
        return {

        }
    },
}
</script>


<style scoped>
     .title{
			font: 24px/1.5 weight;
			color: #fff;
			text-align: center;
			margin: 20px 0;
		}

		.centerInfo{
			position: absolute;
			top: 45%;
			left: 50%;
			transform: translate(-50%,-50%);
		}
		.getFullScreen{
			position: absolute;
			bottom:100px;
			right: 100px;
			z-index: 1111;
		}
		.ctrl-c{
			width: 500px;
			height: auto;
			margin: 20px auto;
		}

		.btn{
			padding: 6px 10px;
			background: #5C96D8;
			margin: 5px;
			color: #fff;
			cursor: pointer;
			border-radius: 4px;
			display: inline-block;
		}
		#testVideo{
			width: 520px;
			height: auto;
			margin: 0 auto;
			outline:2px solid #ccc;
		}
		body,html{
			font-size: 16px;
		}
		.btn{
			font-size: 1rem;
			background: rgba(0,0,0,0.3)!important;
		}
</style>



// WEBPACK FOOTER //
// src/components/Video.vue